let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("25d6q")).then(() => parcelRequire('4DqEm'));